import { gql } from '__generated__';

export default gql(`
  query GetPortal {
    session {
      id
      user {
        id
        first_name
        last_name
        full_name
        email
        locale
        sport_type
        authenticator_available
        authenticator_enabled
        registration_summaries {
          id
          view_token
          deletable_by_participant
          registrations_count
          participant {
            id
          }
          event {
            id
            title
            start_date
            end_date
            project {
              id
              organisation_name
              timezone
            }
            logo {
              id
              url
            }
          }
        }
        participant_projects {
          id
          organisation_name
        }
        project_memberships {
          id
          permissions
          deletable
          project {
            id
            organisation_name
          }
        }
      }
    }
  }
`);
